import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { SaleCarCard } from "@/components/SaleCarCard";
import { Button } from "@/components/ui/button";
import { Seo } from "@/components/Seo";
import { Loader2, ExternalLink } from "lucide-react";

export default function AutoInVendita() {
  const [cars, setCars] = useState([]);
  const [loading, setLoading] = useState(true);
  const [cfg, setCfg] = useState({ autosupermarket: "" });

  useEffect(() => {
    api.get("/sale-cars").then((r) => setCars(r.data)).finally(() => setLoading(false));
    api.get("/config").then((r) => setCfg(r.data)).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-background grain" data-testid="sale-page">
      <Seo title="Auto in Vendita a Pontedera — Usato Garantito | Centro Auto Pontedera" description="Auto usate in vendita a Pontedera (PI): Fiat, Volkswagen, Citroen, Ford, Peugeot, Mercedes e altre. Veicoli selezionati e garantiti. Contattaci per informazioni e prova su strada." path="/vendita" />
      <Navbar />
      <div className="max-w-7xl mx-auto px-6 pt-32 pb-10">
        <div className="font-mono-tech text-xs tracking-[0.3em] uppercase amber mb-3">Showroom</div>
        <h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight uppercase">Auto in Vendita</h1>
        <p className="text-muted-foreground mt-4 max-w-2xl">Veicoli selezionati e controllati dal nostro centro di Pontedera. Contattaci per informazioni, prova su strada o permuta del tuo usato.</p>
        {cfg.autosupermarket && (
          <a href={cfg.autosupermarket} target="_blank" rel="noopener noreferrer" className="inline-block mt-6" data-testid="autosupermarket-btn">
            <Button variant="outline" className="rounded-full border-[#FF9E00]/50 text-[#FF9E00] hover:bg-[#FF9E00]/10 px-6 font-semibold gap-2">
              <ExternalLink className="w-4 h-4" /> Vedi tutte le auto su AutoSupermarket
            </Button>
          </a>
        )}
      </div>
      <div className="max-w-7xl mx-auto px-6 pb-20">
        {loading ? (
          <div className="flex justify-center py-32"><Loader2 className="w-8 h-8 animate-spin text-[#E63946]" /></div>
        ) : cars.length === 0 ? (
          <div className="text-center py-32 text-muted-foreground" data-testid="sale-empty">Al momento non ci sono auto in vendita. Torna presto a trovarci!</div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="sale-cars-grid">
            {cars.map((c, i) => <SaleCarCard key={c.id} car={c} index={i} />)}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}
